import React from 'react';
import { formatMessage } from '../../../../../Localization/formatMessage';
import Messages from '../../../../../Localization/Messages';
import SecondaryButton from '../../../../../Elements/ids/Buttons/SecondaryButton';
import ModalPrimaryButton from '../../../../../Elements/ids/Buttons/ModalPrimaryButton';
import { employerAddressFormId } from '../EmployerAddress';
import { PresentationMode } from '../../../../../Enums/PresentationMode';
import PrimaryButton from '../../../../../Elements/ids/Buttons/PrimaryButton';

const EmployerAddressButtons = ({ closeView, canSubmit, modalMode, closeErrorView }) => {
  return (
    <>
      {modalMode === PresentationMode.Add ? (
        <>
          <SecondaryButton text={formatMessage(Messages.common_cancel)} onClickEvent={closeView} />
          <ModalPrimaryButton
            formId={employerAddressFormId}
            text={formatMessage(Messages.common_create)}
            canSubmit={canSubmit}
          />
        </>
      ) : modalMode === PresentationMode.Edit ? (
        <>
          <SecondaryButton text={formatMessage(Messages.common_cancel)} onClickEvent={closeView} />
          <ModalPrimaryButton
            formId={employerAddressFormId}
            text={formatMessage(Messages.common_save)}
            canSubmit={canSubmit}
          />
        </>
      ) : modalMode === PresentationMode.Error ? (
        <PrimaryButton text={formatMessage(Messages.common_ok)} onClickEvent={closeErrorView} />
      ) : null}
    </>
  );
};

export default EmployerAddressButtons;
